import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Package } from "lucide-react";
import userAPI from "../../api/UserApi";
import { showError } from "../../utils/toastUtils";
import { getDateAgo } from "../../helper/Helper";
import { containerVariants, itemVariants } from "./variants";

// Same fetch as sanwariyaLatest/src/pages/user/Orders.js:
// userAPI.fetchMyOrders() -> res.code === 200 -> res.data
function Orders() {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchMyOrders();
  }, []);

  const fetchMyOrders = async () => {
    setLoading(true);
    try {
      const res = await userAPI.fetchMyOrders();
      if (res.code === 200) {
        setOrders(res.data || []);
      }
    } catch (err) {
      showError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <motion.div
      key="orders"
      variants={containerVariants}
      initial="hidden"
      animate="visible"
      exit={{ opacity: 0, x: 14 }}
      className="flex flex-col gap-3"
    >
      <div className="mb-1.5">
        <span className="block mb-0.5 font-subheading text-[0.54rem] font-bold uppercase tracking-[0.2em] text-[var(--color-text-muted)]">
          Your Purchases
        </span>
        <h2 className="font-heading text-[1.7rem] leading-none tracking-[-0.02em] text-[var(--color-text)]">
          Order History
        </h2>
      </div>

      {loading ? (
        <p className="font-body text-[0.85rem] text-[var(--color-text-muted)]">Loading orders…</p>
      ) : orders.length > 0 ? (
        orders.map((order, i) => (
          <motion.div key={order.orderId || i} variants={itemVariants} className="acc-order">
            <div className="flex h-11 w-11 flex-shrink-0 items-center justify-center rounded border border-[var(--color-border)] bg-[var(--color-bg-alt)]">
              <Package size={18} className="text-[var(--color-text-muted)]" />
            </div>

            <div className="min-w-0 flex-1">
              <div className="mb-0.5 flex flex-wrap items-center gap-2">
                <span className="font-body text-[0.95rem] font-semibold text-[var(--color-text)]">
                  Order #{order.orderId}
                </span>
                <span className="acc-badge bg-[var(--color-accent-gold-light)] text-[var(--color-secondary)]">
                  {order.status?.toUpperCase()}
                </span>
              </div>
              <p className="font-subheading text-[0.52rem] tracking-[0.08em] text-[var(--color-text-muted)]">
                ₹{order.total} · {getDateAgo(order.orderDate)}
              </p>
            </div>

            <div className="flex flex-shrink-0 gap-2">
              <Link to={`/users/order-details/${order.orderId}`} className="acc-btn-o">
                Details
              </Link>
            </div>
          </motion.div>
        ))
      ) : (
        <motion.div variants={itemVariants} className="acc-card flex flex-col items-center gap-3 px-6 py-12 text-center">
          <p className="font-heading text-[1.2rem] text-[var(--color-text)]">
            You haven't placed any order yet
          </p>
          <p className="font-body text-[0.85rem] text-[var(--color-text-muted)]">
            It's time to make your first order.
          </p>
          <Link to="/shop" className="acc-btn-p">
            Shop Now
          </Link>
        </motion.div>
      )}
    </motion.div>
  );
}

export default Orders;